<template>
    <v-app>
        <div style="display: flex; min-height: 100vh; justify-content: center;">
            <div style="width: 450px; align-self: center;">
                <v-alert color="red white--text" v-for="error in errors" :key="error.message">
                    {{ error.message }}
                </v-alert>
                <ValidationObserver ref="observer">
                    <div>
                        <ValidationProvider ref="email" rules="required" name="Login" slim v-slot="{ errors }">
                            <v-text-field filled label="Login" :error-messages="errors" v-model="form.login" @keyup.native.enter="handleSubmit"/>
                        </ValidationProvider>
                    </div>
                    <div>
                        <ValidationProvider ref="password" vid="password" rules="required" name="Hasło" slim v-slot="{ errors }">
                            <v-text-field
                                    filled
                                    label="Hasło"
                                    v-model="form.password"
                                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="showPassword ? 'text' : 'password'"
                                    @click:append="showPassword = !showPassword"
                                    :error-messages="errors"
                                    @keyup.native.enter="handleSubmit"
                            ></v-text-field>
                        </ValidationProvider>
                    </div>
                    <div class="mt-1 d-flex justify-center">
                        <v-btn color="primary" @click="handleSubmit" block>Zaloguj</v-btn>
                    </div>
                </ValidationObserver>
            </div>
        </div>
        <Loader :loading="loading" />
    </v-app>
</template>

<script>
    import {auth} from '@/main';
    import Loader from '../components/Loader';
    import {ValidationObserver, ValidationProvider} from 'vee-validate';
    import {required} from 'vee-validate/dist/rules';
    import {initValidators} from '@/lib/validation/initValidators';
    import errors from "@/mixins/errors";

    initValidators({'required': required});

    export default {
        components: {Loader, ValidationProvider, ValidationObserver},
        mixins: [
            errors,
        ],
        data() {
            return {
                loading: false,
                errors: [],
                showPassword: false,
                form: {
                    login: null,
                    password: null
                }
            }
        },
        methods: {
            async handleSubmit() {
                this.loading = true;
                this.errors = [];
                const valid = await this.$refs.observer.validate();

                if (valid) {
                    await this.save();
                }
            },
            async save() {
                try {
                    await auth.loginWithCredentials(this.form.login, this.form.password);
                } catch (e) {
                    console.error('Error in Login.save():', e);
                    const knownErrors = this.resolveException(e);

                    if (knownErrors) {
                        this.errors = knownErrors;
                        this.loading = false;

                        return;
                    }

                    if (e.response) {
                        if (401 === e.response.status) {
                            this.errors = [{message: 'Nieprawidłowe dane logowania.'}];
                            this.loading = false;

                            return;
                        }
                    }

                    this.errors = [this.getGenericError()];
                }

                this.loading = false;
            }
        }
    }
</script>
